import useRuntimeConfig from '@vl-core/useRuntimeConfig';

const useIsClinicianSubdomain = (): boolean => {
  const { PORTAL_USER_TYPE_CODE } = useRuntimeConfig();

  return PORTAL_USER_TYPE_CODE === 'CLINICIAN';
};

export default useIsClinicianSubdomain;
